import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { __importStar } from 'tslib';
import { ActiveGuard } from './auth/guards/active.guard';
import { SetNewPasswordAuthenticationGuard } from './auth/guards/set-new-password-authentication/set-new-password-authentication.guard';
import { TwoFactorAuthenticationGuard } from './auth/guards/two-factor-authentication/two-factor-authentication.guard';
import { SecurePdfAuthGuard } from './auth/guards/secure-pdf-auth.guard';
import { shortLinkTokenMatcher } from './application/pages/short-link-redirect/short-link-redirect.component';

const routes: Routes = [
  {
    path: 'request-pdf',
    canActivate: [SecurePdfAuthGuard],
    loadChildren: () => import('./application/pages/secure-pdf/secure-pdf.module').then(m => m.SecurePdfModule)
  },
  {
     // Report "Portal page" short link: {WebUrl}/{token} -> decode -> real report page.
    matcher: shortLinkTokenMatcher,
    loadComponent: () => import('./application/pages/short-link-redirect/short-link-redirect.component').then(m => m.ShortLinkRedirectComponent)
  },
  {
    // LEGACY form {WebUrl}/r/{token} - kept so links in already-generated PDFs keep working.
    path: 'r/:token',
    loadComponent: () => import('./application/pages/short-link-redirect/short-link-redirect.component').then(m => m.ShortLinkRedirectComponent)
  },
  {
    path: 'login',
    loadChildren: () => import('./application/pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'logout',
    loadChildren: () => import('./application/pages/logout/logout.module').then(m => m.LogoutModule)
  },
  {
    path: 'verisk-logged-out',
    loadChildren: () => import('./application/pages/verisk-logged-out/verisk-logged-out.module').then(m => m.VeriskLoggedOutModule)
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./application/pages/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  },
  {
    path: 'forgotpassword',
    canActivate: [ActiveGuard],
    loadChildren: () => import('./application/pages/forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule)
  },
  {
    path: 'resetpassword/:resetPasswordToken',
    loadChildren: () => import('./application/pages/resetpassword/resetpassword.module').then(m => m.ResetpasswordModule)
  },
  {
    path: 'client/expiration',
    loadChildren: () => import('./application/pages/client-expiration/client-expiration.module').then(m => m.ClientExpirationModule)
  },
  {
    path: 'reset-password-response/:Id',
    canActivate: [ActiveGuard],
    loadChildren: () => import('./application/pages/reset-password-response/reset-password-response.module').then(m => m.ResetPasswordResponseModule)
  },
  {
    path: 'signup',
    canActivate: [ActiveGuard],
    loadChildren: () => import('./application/pages/signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'setnewpassword',
    canActivate: [SetNewPasswordAuthenticationGuard],
    loadChildren: () => import('./application/pages/setupnewpassword/setupnewpassword.module').then(m => m.SetupnewpasswordModule)
  },
  { path: '', 
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'code-verification',
    loadChildren: () => import('../app/application/pages/code-verification/code-verification.module').then(m => m.CodeVerificationModule),
    canActivate:[TwoFactorAuthenticationGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
